import { useState } from "react";
import { digestMessage } from "./lib/Hash";
import'./Login.css';

type LoginProps = {
  handleLoggedIn: (signedUrl: string, companySeed: string) => void,
  handleLoginFailed: () => void
};

function Login(props: LoginProps) {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const storedCompanySalt = window.localStorage.storedCompanySalt || '';
  const [companySalt, setCompanySalt] = useState(storedCompanySalt);
  const [message, setMessage] = useState('');
  const handleOnClick = async () => {
    setMessage('認証中(数秒かかる事があります)');
    const url ='https://hashing-uploader.cross-fact.app/auth';
    const validator = await digestMessage(companySalt);
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache',
      body: JSON.stringify( { loginId: id, password, validator } )
    }).then(response => {
      if(response.status === 200) {
        window.localStorage.storedCompanySalt ||= companySalt
        response.text().then((signedUrl) => {
          props.handleLoggedIn(signedUrl, companySalt);
        });
      } else {
        console.log(response.status);
        setMessage('');
        props.handleLoginFailed();
      }
    }).catch(error => {
      console.error(error);
      props.handleLoginFailed();
    });
  }
  return (
    <div className="Login">
      <p>ID:<input type="text" value={id} onChange={(e) => { setId(e.target.value) }} /></p>
      <p>パスワード:<input type="password" value={password} onChange={(e) => { setPassword(e.target.value) }} /></p>
      <p hidden={!!storedCompanySalt}>ハッシュソルト:<input type="password" value={companySalt} onChange={(e) => { setCompanySalt(e.target.value) }}/></p>
      <p><button onClick={handleOnClick}>ログイン</button></p>
      <p>{message}</p>
    </div>
  );
}

export default Login;
